import { Box, Typography } from '@mui/material';
import React from 'react';

const ExplainatoryVideo = () => {
    return (
        <div>
            {/* video */}
            <Box sx={{ background: '#EEEFFF', width: { xs: '344px', sm: '635px', md: '860px', lg: '1158px', xl: '80%' }, height: { xs: '161px', sm: '230px', md: '360px', lg: '497px' }, mx: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', mt: '10px', mb: { xs: '20px', md: '28px' } }}>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '20px' }, lineHeight: { xs: '14px', sm: '16px', md: '18px', lg: '20px' }, color: '#433ED1', textAlign: 'center' }}>
                    Explainatory Video
                </Typography>
            </Box>
        </div>
    );
};

export default ExplainatoryVideo;